const initialState = {
	value: "",
	dir: ""
};

export default (state = initialState, action) => {
	switch (action.type) {
		case "SET_SORT_VALUE":
			return {
				...state,
				value: action.value
			};
		case "SET_SORT_DIR":
			return {
				...state,
				dir: action.dir
			};
		case "SET_SORT_VALUE_AND_DIR":
			return {
				...state,
				value: action.value,
				dir: action.dir
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/sort.js